import { Controller } from '@hotwired/stimulus';

// Flashes the matching quote card when its map pin is clicked.
export default class extends Controller {
  connect() {
    this._onSelectFromMap = (event) => this._flashCard(event.detail);
    window.addEventListener('quotesMap:selectValuer', this._onSelectFromMap);
  }

  disconnect() {
    window.removeEventListener('quotesMap:selectValuer', this._onSelectFromMap);
  }

  _flashCard(marker) {
    if (!marker || (marker.kind || '').toLowerCase() !== 'valuers' || marker.id == null) return;

    const card = this.element.querySelector(
      `[data-card][data-id="${CSS.escape(String(marker.id))}"]`,
    );
    if (!card) return;

    card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    card.classList.add('quote-card-flash');
    setTimeout(() => card.classList.remove('quote-card-flash'), 1000);
  }
}
